window.okeReviewsWidgetOnInit = function () {
    const reviewMain = document.querySelector(".js-okeReviews-reviews-main");
    if (reviewMain) {
        const config = { childList: true };
        const callback = function (mutationList) {
            for (const mutation of mutationList) {
                mutation.addedNodes.forEach((n) => formatDateForElement(n));
                mutation.addedNodes.forEach((n) => moveReviewTitle(n));
            }
        };
        const observer = new MutationObserver(callback, config);
        observer.observe(reviewMain, config);

        const reviews = document.querySelectorAll(".okeReviews-reviews-review");
        reviews.forEach((n) => formatDateForElement(n));
        reviews.forEach((n) => moveReviewTitle(n));      
    }

    const warButton = document.querySelector(".okeReviews-reviewsWidget-header .js-okeReviews-writeReview");
    const controlsSelect = document.querySelector(".okeReviews-reviews .okeReviews-reviews-controls-sort");
    if (warButton && controlsSelect) {
        controlsSelect.insertAdjacentElement("afterend", warButton);
    }
  
    const ratingDistribution = document.querySelector(".js-or-rtgDis");
    const productAggregate = document.querySelector(".okeReviews-product-aggregate > .okeReviews ");

    // Move Rating Distribution beside custom Aggregate Reviews Summary
    if (ratingDistribution && productAggregate) {
        productAggregate.insertAdjacentElement("beforeend", ratingDistribution);
    }
};

window.okeReviewsQandaOnInit = function () {
    const questionMain = document.querySelector(".js-okeReviews-questions-main");
    const totalRating = document.querySelector(".okeReviews-total").innerText;

    document.querySelector(".okeReviews-reviewsSummary-ratingCount").insertAdjacentHTML("beforebegin", 
    `<span style="position: relative;top: 2px;margin-right: 5px;font-weight: 400;">
        ${totalRating}/5
    </span>`
    );
    if (questionMain) {
        const config = { childList: true };
        const callback = function (mutationList) {
            for (const mutation of mutationList) {
                mutation.addedNodes.forEach((n) => formatDateForElement(n));
            }
        };
        const observer = new MutationObserver(callback, config);
        observer.observe(questionMain, config);

        const questions = document.querySelectorAll(".okeReviews-question");
        questions.forEach((n) => formatDateForElement(n));
    }
};

function formatDateForElement(nodeElement) {
    if (nodeElement) {
        const reviewDates = document.querySelectorAll("[data-oke-reviews-date]");
        for (const reviewDate of reviewDates) {
            const dateIsoString = reviewDate.getAttribute("data-oke-reviews-date");
            const date = new Date(dateIsoString);
            const localeDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
            reviewDate.innerText = localeDate;
        }
    }
}

function moveReviewTitle(nodeElement) {
    if (nodeElement) {
        const reviewTitle = nodeElement.querySelector('.okeReviews-review-main-heading');
        const starRating = nodeElement.querySelector('.okeReviews-review-starRating');
        // Insert Review Title Into Star Rating
        starRating.insertAdjacentElement('beforeend', reviewTitle);
    }
}